module.exports = __webpack_public_path__ + "img/ring_g_c_null_1.9e0b73d5.png";